// Set to true only by product-form.js onSubmitHandler; prevents Rebuy /cart/add from opening drawer
window.userInitiatedCartAdd = false;

// Rebuy Tiered Progress Bar: line-item exclusion keys used by Rebuy's own subtotal formula.
// Both literals are CONFIRMED -- recovered at runtime from the live app-hosted rebuy.js
// bundle (EXCLUDE_FROM_PROGRESS_BAR_SUBTOTAL and the _attribution constant), and browser
// parity testing against Rebuy's progressBarSubtotal() passed on all cases.
// CAVEAT: the exclude tag's literal reads as shipping-related rather than progress-bar
// related, so re-verify it against the bundle if the tag filter ever appears not to work.
// TIERED_PROGRESS_BAR_ATTRIBUTION must NOT collide with the Gift-with-Purchase attribution
// ('Rebuy Gift with Purchase'), or GWP lines would be wrongly excluded from the subtotal.
// With the current single decorative tier the progress bar injects no line items at all,
// so the attribution filter is inert today.
// Tags are compared case-SENSITIVELY with trim() only, matching Rebuy. Do not fold case.
const TIERED_PROGRESS_BAR_ATTRIBUTION = 'Rebuy Tiered Progress Bar';
const EXCLUDE_TAG = 'smart-cart-shipping-excluded';

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    // Flag to track if we're closing via rebuy close button
    this.closingViaRebuyClose = false;
    
    // Flag to track if smart cart is loaded
    this.smartCartLoaded = false;

    // Removed Escape key and overlay click handlers - only rebuy close button will close drawer
    // this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    // this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.toggleCategoryReminder();
    this.handleRebuyCartClose();
    this.handleRebuyCartOpen();
    this.preventActiveClassRemoval();
    this.interceptAddToCart();
  }

  toggleCategoryReminder(){
    $('body').on('click', '[category-reminder-toggler]', function(){
      $('.cart-drawer_category-reminder').toggleClass('open');
    })
  }

  handleRebuyCartClose(){
    const closeDrawer = (drawer) => {
      if (drawer) {
        // Set flag to allow closing
        drawer.closingViaRebuyClose = true;
        drawer.classList.remove('active');
        drawer.style.display = 'none';
        document.body.classList.remove('overflow-hidden');
        // Reset flag after a short delay
        setTimeout(() => {
          drawer.closingViaRebuyClose = false;
        }, 100);
      }
    };

    document.addEventListener('click', (event) => {
      const drawer = document.querySelector('.mrMiniCart-drawer');

      // Close drawer when clicking rebuy close button
      if (event.target.closest('#rebuy-cart-close')) {
        closeDrawer(drawer);
      }

      // Close drawer when clicking rebuy product title
      if (event.target.closest('.rebuy-cart__flyout-item-product-title')) {
        closeDrawer(drawer);
      }

      // Close drawer when clicking the overlay backdrop (theme or Rebuy)
      if (event.target.closest('#CartDrawer-Overlay') || event.target.closest('.rebuy-cart__background')) {
        closeDrawer(drawer);
      }
    });
  }

  handleRebuyCartOpen(){
    const drawer = this;

    // Listen for rebuy smartcart ready event
    document.addEventListener('rebuy:smartcart.ready', (event) => {
      drawer.smartCartLoaded = true;
    });

    // Check if smart cart is already loaded (in case event already fired)
    if (document.querySelector('.rebuy-cart__flyout') || document.querySelector('#rebuy-cart')) {
      this.smartCartLoaded = true;
    }

    this.watchRebuyCartForCountChanges();
  }

  watchRebuyCartForCountChanges() {
    let debounceTimer = null;

    const syncBubbleCount = () => {
      fetch('/cart.js')
        .then((r) => r.json())
        .then((cart) => {
          const bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
          if (!bubble) return;
          const visibleCount = bubble.querySelector('span[aria-hidden="true"]');
          const hiddenCount = bubble.querySelector('.visually-hidden');
          if (visibleCount) visibleCount.textContent = cart.item_count < 100 ? cart.item_count : '';
          if (hiddenCount) hiddenCount.textContent = cart.item_count;
          bubble.style.display = cart.item_count === 0 ? 'none' : '';
        })
        .catch(() => {});
    };

    const attachObserver = (flyout) => {
      const observer = new MutationObserver(() => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(syncBubbleCount, 150);
      });
      observer.observe(flyout, { childList: true, subtree: true });
    };

    // Attach immediately if flyout already exists, otherwise wait for it
    const existingFlyout = document.querySelector('.rebuy-cart__flyout, #rebuy-cart');
    if (existingFlyout) {
      attachObserver(existingFlyout);
    } else {
      const waitForFlyout = new MutationObserver(() => {
        const flyout = document.querySelector('.rebuy-cart__flyout, #rebuy-cart');
        if (flyout) {
          waitForFlyout.disconnect();
          attachObserver(flyout);
        }
      });
      waitForFlyout.observe(document.body, { childList: true, subtree: true });
    }
  }

  interceptAddToCart(){
    // Intercept all fetch requests to /cart/add to reset the userInitiatedCartAdd flag
    const originalFetch = window.fetch;

    window.fetch = function(...args) {
      const [url] = args;
      const isAddToCart = typeof url === 'string' && url.includes('/cart/add');
      
      return originalFetch.apply(this, args).then(response => {
        if (isAddToCart) {
          window.userInitiatedCartAdd = false;
        }
        return response;
      });
    };
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      if (!event.isTrusted) return;
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (!this.smartCartLoaded) return;
    
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    
    // Reset display property if it was set to none by rebuy close button
    if (this.style.display === 'none') {
      this.style.display = '';
    }
    
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    // No-op: Rebuy calls close() internally on every interaction inside the cart.
    // Actual closing is handled exclusively by handleRebuyCartClose() → closeDrawer().
  }

  preventActiveClassRemoval() {
    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.attributeName !== 'class') continue;
        const hadActive = mutation.oldValue ? mutation.oldValue.split(' ').includes('active') : false;
        if (hadActive && !this.classList.contains('active') && !this.closingViaRebuyClose) {
          this.classList.add('active');
        }
      }
    }).observe(this, { attributes: true, attributeFilter: ['class'], attributeOldValue: true });
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      const sectionHTML = parsedState.sections && parsedState.sections[section.id];
      if (sectionElement && sectionHTML) {
        sectionElement.innerHTML = this.getSectionInnerHTML(sectionHTML, section.selector);
      }
    }));

    setTimeout(() => {
      // Removed overlay click handler - only rebuy close button will close drawer
      // this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      // this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// Rebuy & Okendo integration
function injectOkendoStarsInRebuyWidgets() {
  const productBlocks = document.querySelectorAll('.rebuy-product-block');
  let injectedAny = false;

  productBlocks.forEach(block => {
    // 1. Check if Okendo widget is already injected
    if (block.querySelector('[data-oke-star-rating]')) {
      return;
    }

    // 2. Find the product ID from class list (e.g. product-id-10162133532963)
    let productId = null;
    block.classList.forEach(cls => {
      if (cls.startsWith('product-id-')) {
        productId = cls.replace('product-id-', '');
      }
    });

    if (!productId) return;

    // 3. Find the container to insert into (e.g. inside .rebuy-product-info)
    const productInfo = block.querySelector('.rebuy-product-info');
    if (!productInfo) return;

    const productTitle = productInfo.querySelector('.rebuy-product-title');
    if (!productTitle) return;

    // 4. Create the Okendo star rating element
    const ratingDiv = document.createElement('div');
    ratingDiv.className = 'okeReviews oke-sr-stars-only';
    ratingDiv.setAttribute('data-oke-star-rating', '');
    ratingDiv.setAttribute('data-oke-reviews-product-id', `shopify-${productId}`);
    ratingDiv.setAttribute('data-oke-scroll-disabled', 'true');

    // Insert after the title
    productTitle.after(ratingDiv);
    injectedAny = true;
  });

  // 5. If we injected any new widgets, initialize them via Okendo API
  if (injectedAny && window.okeWidgetApi && typeof window.okeWidgetApi.initAllWidgets === 'function') {
    window.okeWidgetApi.initAllWidgets();
  }
}

function isOutsideCartProgressMount(el) {
  return el && !el.closest('[data-rebuy-progress-mount]');
}

function setCartProgressFooterState(footer, hasProgress) {
  if (!footer) return;
  footer.classList.toggle('has-rebuy-progress', hasProgress);
}

/* ------------------------------------------------------------------------------------------
 * Rebuy Tiered Progress Bar parity (/cart page)
 *
 * Rebuy Smart Cart does not initialise on /cart, so Rebuy.SmartCart.progressBar is null
 * there and the theme has to reproduce Rebuy's own subtotal formula
 * (SmartCart.progressBarSubtotal) to keep the /cart bar in step with the drawer bar.
 *
 * All bar configuration (tier minimums, exclude_discount_in_subtotal, discounted_by,
 * excluded_products) is read from the live Rebuy config via window.__rebuyConfigFetch --
 * nothing about the bar is duplicated into theme settings.
 *
 * Everything below works in INTEGER CENTS. Tier minimums arrive from Rebuy in dollars and
 * are converted once, at the point of comparison.
 * ---------------------------------------------------------------------------------------- */

// Reads the server-rendered cart state emitted by sections/main-cart-items.liquid. That
// script tag lives inside .js-contents-footer, which assets/cart.js re-renders on every
// AJAX cart update, so it is already fresh by the time the cart events below fire.
function readCartProgressState() {
  const el = document.querySelector('[data-cart-progress-state]');
  if (!el) return null;
  try {
    return JSON.parse(el.textContent);
  } catch (error) {
    console.warn('[cart-progress] Could not parse [data-cart-progress-state]:', error);
    return null;
  }
}

// Product tags are not present on Shopify's AJAX cart line items, only on the Liquid-rendered
// state block. Keyed by variant id so a state object built from an event payload can still
// resolve the EXCLUDE_TAG check.
function getCartProgressTagMap(state) {
  const source = state || readCartProgressState();
  const map = {};
  if (source && Array.isArray(source.items)) {
    source.items.forEach((item) => {
      map[String(item.variant_id)] = item.tags;
    });
  }
  return map;
}

let unmappedVariantWarned = false;

// Visibility only, no behaviour change: a variant present in an AJAX payload but missing
// from the state block means its tags cannot be resolved, so an EXCLUDE_TAG on that line
// would be silently ignored and the /cart bar could drift from the drawer.
function warnOnUnmappedPayloadVariants(payload, tagsByVariantId) {
  if (unmappedVariantWarned || !payload || !Array.isArray(payload.items)) return;
  const missing = payload.items
    // /cart/update.js echoes removed lines back with quantity 0. They are absent from the
    // state block by design, so skip them or this warns on every quantity change. They
    // carry original/final 0 and so do not affect the subtotal either way.
    .filter((item) => Number(item.quantity) > 0)
    .map((item) => String(item.variant_id))
    .filter((variantId) => !Object.prototype.hasOwnProperty.call(tagsByVariantId, variantId));
  if (!missing.length) return;
  unmappedVariantWarned = true;
  console.warn(
    '[cart-progress] Cart payload contains variant ids missing from ' +
      '[data-cart-progress-state]; their product tags cannot be resolved, so an ' +
      'EXCLUDE_TAG on those lines will be ignored:',
    missing
  );
}

function normalizeTags(tags) {
  if (Array.isArray(tags)) return tags.map((tag) => String(tag).trim());
  if (typeof tags === 'string') return tags.split(',').map((tag) => tag.trim());
  return [];
}

// Mirrors Rebuy's `e.final_line_price || e.final_price * e.quantity` (and the original_*
// equivalent), including the `||` fallthrough on a zero line price.
function itemFinalCents(item) {
  return Number(item.final_line_price) || Number(item.final_price) * Number(item.quantity) || 0;
}

function itemOriginalCents(item) {
  return Number(item.original_line_price) || Number(item.original_price) * Number(item.quantity) || 0;
}

function itemAttribution(item) {
  if (item.properties && item.properties._attribution) return item.properties._attribution;
  return item.attribution || null;
}

function isExcludedFromProgressBar(item, bar, tagsByVariantId) {
  if (itemAttribution(item) === TIERED_PROGRESS_BAR_ATTRIBUTION) return true;

  let rawTags = item.tags;
  if (rawTags === undefined && item.product) rawTags = item.product.tags;
  if (rawTags === undefined) rawTags = tagsByVariantId[String(item.variant_id)];
  if (normalizeTags(rawTags).includes(EXCLUDE_TAG)) return true;

  if (bar.discounted_by === 'functions' && Array.isArray(bar.excluded_products)) {
    const variantId = Number(item.variant_id);
    const excluded = bar.excluded_products.some(
      (entry) => Array.isArray(entry.variant_ids) && entry.variant_ids.includes(variantId)
    );
    if (excluded) return true;
  }

  return false;
}

// ASSUMPTION: the shape of an order-discount tier is unconfirmed. This is only used to
// decide whether to warn, so it is kept deliberately narrow.
function hasOrderDiscountTier(bar) {
  return (bar.tiers || []).some(
    (tier) =>
      tier.type === 'discount' &&
      (tier.discount_type === 'order' || tier.discount_applies_to === 'order' || tier.order_discount === true)
  );
}

let orderDiscountTierWarned = false;

function discountCodeTotalFromApplications(applications) {
  if (!Array.isArray(applications)) return 0;
  return applications
    .filter((application) => application.type === 'discount_code')
    .reduce((total, application) => total + (Number(application.total_allocated_amount) || 0), 0);
}

// Port of Rebuy SmartCart.progressBarSubtotal. Returns integer cents.
function getProgressSubtotalCents(bar, state) {
  if (!bar || !state) return 0;

  const originalTotalCents = Number(state.original_total_price) || 0;
  const totalDiscountCents = Number(state.total_discount) || 0;
  const items = Array.isArray(state.items) ? state.items : [];
  const tagsByVariantId = state.tagsByVariantId || getCartProgressTagMap();

  const excludedItems = items.filter((item) => isExcludedFromProgressBar(item, bar, tagsByVariantId));
  const excludedFinalCents = excludedItems.reduce((total, item) => total + itemFinalCents(item), 0);
  const excludedOriginalCents = excludedItems.reduce((total, item) => total + itemOriginalCents(item), 0);

  const orderDiscountTier = hasOrderDiscountTier(bar);
  if (orderDiscountTier && !orderDiscountTierWarned) {
    orderDiscountTierWarned = true;
    console.warn(
      '[cart-progress] Rebuy order-discount tier detected. This theme does not implement ' +
        "Rebuy's orderDiscountTotal() branch of progressBarSubtotal; falling back to the " +
        'pre-discount basis. The /cart progress bar may disagree with the Smart Cart drawer ' +
        'until that branch is implemented.'
    );
  }

  let cents;
  if (orderDiscountTier || bar.exclude_discount_in_subtotal) {
    // Pre-discount basis, less the pre-discount value of excluded lines.
    cents = originalTotalCents - excludedOriginalCents;
  } else {
    const discountCodeCents =
      Number(state.discount_code_total) ||
      discountCodeTotalFromApplications(state.cart_level_discount_applications) ||
      0;
    // ASSUMPTION: gift cards are applied at checkout and appear in neither the Liquid cart
    // object nor the AJAX cart payload, so there is nothing to subtract on the storefront.
    const giftCardCents = 0;
    cents = originalTotalCents - totalDiscountCents - excludedFinalCents - discountCodeCents - giftCardCents;
  }

  return Math.max(0, Math.round(cents));
}

function tierMinimumCents(tier) {
  return Math.round(Number(tier.minimum) * 100);
}

function getProgressFillPercent(cents, tiers) {
  const count = tiers.length;
  let completed = 0;
  for (let i = 0; i < count; i += 1) {
    const min = tierMinimumCents(tiers[i]);
    const prev = i === 0 ? 0 : tierMinimumCents(tiers[i - 1]);
    if (cents >= min) {
      completed += 1;
      if (i === count - 1) return 100;
    } else {
      const span = min - prev;
      const part = span > 0 ? Math.min(Math.max(cents - prev, 0) / span, 1) : 0;
      return ((completed + part) / count) * 100;
    }
  }
  return 0;
}

function getProgressPromptLabel(cents, tiers) {
  const nextTier = tiers.find((tier) => cents < tierMinimumCents(tier));
  const lastTier = tiers[tiers.length - 1];
  if (!nextTier) {
    return (
      lastTier.decorative_amount_reached_label_text ||
      lastTier.discount_amount_reached_label_text ||
      lastTier.product_amount_reached_label_text ||
      ''
    );
  }
  const remainingCents = Math.max(tierMinimumCents(nextTier) - cents, 0);
  // TODO: en-NZ/NZD is hard-coded. This breaks under Shopify Markets multi-currency -- a
  // non-NZD presentment currency would still be formatted as NZD. The store is a single NZ
  // market today, so fixing it is out of scope here.
  const remainingText = (remainingCents / 100).toLocaleString('en-NZ', {
    style: 'currency',
    currency: 'NZD',
  });
  const template =
    nextTier.decorative_amount_remaining_label_text ||
    nextTier.discount_amount_remaining_label_text ||
    nextTier.product_amount_remaining_label_text ||
    'You are {{remaining_amount}} away';
  return template.replace(/\{\{\s*remaining_amount\s*\}\}/g, remainingText);
}

function getLiveProgressStepIcon(index) {
  const icons = Array.from(
    document.querySelectorAll(
      '#rebuy-cart .rebuy-cart__progress-step-icon, .rebuy-cart__flyout .rebuy-cart__progress-step-icon'
    )
  ).filter(isOutsideCartProgressMount);
  return icons[index] ? icons[index].innerHTML : '';
}

function buildProgressReplica(bar, cents) {
  const tiers = bar.tiers;
  const replica = document.createElement('div');
  replica.setAttribute('data-rebuy-component', 'progress-bar');
  replica.setAttribute('data-rebuy-progress-replica', '');

  const steps = document.createElement('div');
  steps.className = `rebuy-cart__progress-step-wrapper count-${tiers.length}`;
  const stepWidth = `${100 / tiers.length}%`;

  tiers.forEach((tier, index) => {
    const step = document.createElement('div');
    step.className = 'rebuy-cart__progress-step';
    if (cents >= tierMinimumCents(tier)) step.classList.add('complete');
    step.style.width = stepWidth;

    const icon = document.createElement('div');
    icon.className = 'rebuy-cart__progress-step-icon';
    const liveIcon = getLiveProgressStepIcon(index);
    icon.innerHTML =
      liveIcon ||
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="1.6" d="M6 8h12l-1 12H7L6 8z"/><path fill="none" stroke="currentColor" stroke-width="1.6" d="M9 8V7a3 3 0 0 1 6 0v1"/><path fill="none" stroke="currentColor" stroke-width="1.6" d="M12 12v4M10 14h4"/></svg>';

    const label = document.createElement('span');
    label.className = 'rebuy-cart__progress-step-label';
    label.textContent = tier.custom_tier_label_text || `$${tier.minimum}`;

    step.append(icon, label);
    steps.append(step);
  });

  const wrapper = document.createElement('div');
  wrapper.className = 'rebuy-cart__progress-bar-wrapper';

  const meter = document.createElement('div');
  meter.className = 'rebuy-cart__progress-bar-meter has-progress';
  const fill = document.createElement('div');
  fill.className = 'rebuy-cart__progress-bar-meter-fill';
  fill.style.width = `${getProgressFillPercent(cents, tiers)}%`;
  meter.append(fill);

  const prompt = document.createElement('div');
  prompt.className = 'rebuy-cart__progress-bar-prompt';
  prompt.innerHTML = getProgressPromptLabel(cents, tiers);

  wrapper.append(meter, prompt);
  replica.append(steps, wrapper);
  return replica;
}

let cachedProgressBar = null;

function withProgressBar(callback) {
  if (cachedProgressBar) {
    callback(cachedProgressBar);
    return;
  }
  const configPromise = window.__rebuyConfigFetch;
  if (!configPromise || typeof configPromise.then !== 'function') return;
  configPromise.then((payload) => {
    const smartCart = payload && payload.data && payload.data.smart_cart;
    const tpb = ((smartCart && smartCart.components) || []).find(
      (component) => component.type === 'tiered_progress_bar' && component.visibility_status !== 'hidden'
    );
    const bar = tpb && tpb.settings && tpb.settings.bars && tpb.settings.bars[0];
    if (!bar || !Array.isArray(bar.tiers) || !bar.tiers.length) return;
    cachedProgressBar = bar;
    callback(bar);
  });
}

function updateProgressReplica(mount, bar, cents) {
  const existing = mount.querySelector('[data-rebuy-progress-replica]');
  const fillWidth = `${getProgressFillPercent(cents, bar.tiers)}%`;
  const promptHtml = getProgressPromptLabel(cents, bar.tiers);

  if (!existing) {
    const replica = buildProgressReplica(bar, cents);
    if (!replica.querySelector('.rebuy-cart__progress-bar-prompt').innerHTML) {
      console.warn(
        '[cart-progress] Rebuy progress bar label resolved empty, so the /cart replica was ' +
          'not mounted. Check the tier label text fields in Rebuy admin.',
        { tiers: bar.tiers, subtotalCents: cents }
      );
      return;
    }
    mount.replaceChildren(replica);
    return;
  }

  const fill = existing.querySelector('.rebuy-cart__progress-bar-meter-fill');
  if (fill && fill.style.width !== fillWidth) fill.style.width = fillWidth;

  const prompt = existing.querySelector('.rebuy-cart__progress-bar-prompt');
  if (prompt && prompt.innerHTML !== promptHtml) prompt.innerHTML = promptHtml;

  existing.querySelectorAll('.rebuy-cart__progress-step').forEach((step, index) => {
    const tier = bar.tiers[index];
    if (!tier) return;
    step.classList.toggle('complete', cents >= tierMinimumCents(tier));
  });
}

function renderRebuyProgressFallback(mount, footer, state) {
  withProgressBar((bar) => {
    // Resolved inside the callback: the Rebuy config promise is async, so re-read the DOM
    // state here if the caller did not hand us a payload-derived one.
    const resolvedState = state || readCartProgressState();
    updateProgressReplica(mount, bar, getProgressSubtotalCents(bar, resolvedState));
    setCartProgressFooterState(footer, true);
  });
}

function syncRebuyProgressToCartPage(state) {
  const mount = document.querySelector('[data-rebuy-progress-mount]');
  if (!mount) return;

  const footer = mount.closest('.cart__footer');
  const cartIsEmpty = Boolean(document.querySelector('#main-cart-footer.is-empty'));

  if (cartIsEmpty) {
    mount.replaceChildren();
    setCartProgressFooterState(footer, false);
    return;
  }

  renderRebuyProgressFallback(mount, footer, state);
}

// A cart payload is only trusted if it carries everything the formula needs; otherwise we
// fall back to re-reading the server-rendered state block.
function isUsableCartPayload(payload) {
  return Boolean(
    payload &&
      typeof payload === 'object' &&
      Array.isArray(payload.items) &&
      typeof payload.original_total_price === 'number' &&
      typeof payload.total_discount === 'number'
  );
}

function cartProgressStateFromPayload(payload) {
  // AJAX cart line items carry no product tags; borrow them from the state block.
  const tagsByVariantId = getCartProgressTagMap();
  warnOnUnmappedPayloadVariants(payload, tagsByVariantId);
  return {
    original_total_price: payload.original_total_price,
    total_price: payload.total_price,
    total_discount: payload.total_discount,
    cart_level_discount_applications: payload.cart_level_discount_applications,
    items: payload.items,
    tagsByVariantId,
  };
}

function cartProgressStateFromEvent(event) {
  const payload = event && event.detail;
  return isUsableCartPayload(payload) ? cartProgressStateFromPayload(payload) : undefined;
}

function startRebuyProgressSync() {
  syncRebuyProgressToCartPage();
  let attempts = 0;
  const timer = setInterval(() => {
    attempts += 1;
    syncRebuyProgressToCartPage();
    if (
      document.querySelector('[data-rebuy-progress-mount] .rebuy-cart__progress-step-wrapper') ||
      attempts >= 40
    ) {
      clearInterval(timer);
    }
  }, 250);
}

document.addEventListener('rebuy:widget.ready', injectOkendoStarsInRebuyWidgets);
document.addEventListener('rebuy:widget.change', injectOkendoStarsInRebuyWidgets);
document.addEventListener('rebuy:widget.update', injectOkendoStarsInRebuyWidgets);
document.addEventListener('rebuy:smartcart.ready', injectOkendoStarsInRebuyWidgets);

// Dead on /cart: Smart Cart does not render there (shouldRender() is false when
// cart_page_enabled is true), so no rebuy:smartcart.* event ever fires. Left in place
// deliberately -- these listeners are harmless and still correct on drawer pages.
document.addEventListener('rebuy:smartcart.ready', syncRebuyProgressToCartPage);
document.addEventListener('rebuy:smartcart.change', syncRebuyProgressToCartPage);
document.addEventListener('rebuy:smartcart.update', syncRebuyProgressToCartPage);

// Primary triggers on /cart.
document.addEventListener('rebuy:cart.change', (event) => {
  syncRebuyProgressToCartPage(cartProgressStateFromEvent(event));
});

document.addEventListener('cart:updated', (event) => {
  syncRebuyProgressToCartPage(cartProgressStateFromEvent(event));
});

if (window.jQuery) {
  window.jQuery(window).on('cart:quantity-update', (_event, payload) => {
    syncRebuyProgressToCartPage(isUsableCartPayload(payload) ? cartProgressStateFromPayload(payload) : undefined);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', startRebuyProgressSync);
} else {
  startRebuyProgressSync();
}

// Fallback observer to ensure they get loaded even if events fire early or rendering is slow
const rebuyObserver = new MutationObserver((mutations) => {
  let shouldCheck = false;
  for (let mutation of mutations) {
    if (
      (mutation.target && mutation.target.closest && mutation.target.closest('[data-rebuy-progress-mount]')) ||
      (mutation.target && mutation.target.classList && mutation.target.classList.contains('rebuy-cart__progress-bar-prompt') && mutation.target.closest('[data-rebuy-progress-mount]'))
    ) {
      continue;
    }
    if (
      mutation.target &&
      mutation.target.classList &&
      mutation.target.classList.contains('rebuy-product-block')
    ) {
      shouldCheck = true;
      break;
    }
    if (mutation.addedNodes.length > 0) {
      for (let node of mutation.addedNodes) {
        if (
          node.nodeType === 1 &&
          !node.closest('[data-rebuy-progress-mount]') &&
          (node.classList.contains('rebuy-product-block') ||
            node.querySelector('.rebuy-product-block'))
        ) {
          shouldCheck = true;
          break;
        }
      }
    }
    if (shouldCheck) break;
  }
  if (shouldCheck) {
    injectOkendoStarsInRebuyWidgets();
  }
});

// Start observing document body for changes in rebuy product blocks
rebuyObserver.observe(document.body, {
  childList: true,
  subtree: true
});
